import React, { Fragment } from 'react';
import './App.css';
import Sidebar from './Sidebar';
import CourseArea from './CourseArea';
import Cart from './Cart'
import SearchAndFilter from './SearchAndFilter';
import data from './data/course_data.json'
import completed from './data/complete.json'
import { Row, Col } from 'antd'
import { Navbar } from 'react-bootstrap';
import 'antd/dist/antd.css';
import { notification } from 'antd'
import Recommendation from './Recommendation'


class RateNRecommendation extends React.Component {
    constructor(props) {
        super(props);
    }

    rate(course) {
        alert(course)
    }
    render() {
        return (
            <Fragment>
                <Navbar sticky="top" style={{ backgroundColor: 'white', marginBottom: '40px' }}>
                    <Col span={1}></Col>
                    <div>
                        <h1 style={{ fontSize: "30px", fontWeight: "bolder", whiteSpace: 'nowrap' }}>Rate & Recommendation</h1>
                    </div>
                    <Col span={1}></Col>
                </Navbar>

                <Row>
                    <Col span={1}></Col>
                    <Col span={10}>
                        <CourseArea
                            rate={(data) => this.rate(data)}
                            completedCourses={this.props.completedCourses}
                            isTaken={true}
                        />
                    </Col>
                    <Col span={2}></Col>
                    <Col span={10}>
                        <Recommendation />
                    </Col>
                    <Col span={1}></Col>
                </Row>
            </Fragment>
        )
    }
}

export default RateNRecommendation;
